// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableDebug: true,

  numero_WhatsApp: "+393533738502",
  numero_telefono: "tel:+390818435649",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',
  */

  urlWeb: 'https://bagformazione.discentya.it/',
  urlMaterialeDidattico: 'https://bagformazione.discentya.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://bagformazione.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://bagformazione.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://bagformazione.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://bagformazione.discentya.it/api/',

  urlStampa: 'https://bagformazione.discentya.it/stampe/',

  urlAttestati: 'https://bagformazione.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://bagformazione.discentya.it/pages/certificate/',
  urlImagePartners: 'https://bagformazione.discentya.it/assets/media/partners/',
  urlImageMedia: 'https://bagformazione.discentya.it/assets/media/',

};

